"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieManager = void 0;
var cookie = __importStar(require("cookie"));
var defaultOptions = {
    path: '/',
    httpOnly: false
};
var CookieManager = /** @class */ (function () {
    function CookieManager() {
        this.values = {};
        this.isBrowser = typeof document !== 'undefined' && !!document.cookie;
    }
    CookieManager.prototype.fill = function (cookies, domain) {
        var result = cookie.parse(cookies);
        this.values = Object.keys(result).reduce(function (values, key) {
            values[key] = { value: result[key], changed: false };
            return values;
        }, {});
        this.domain = domain;
    };
    CookieManager.prototype.get = function (key) {
        var _a;
        return (_a = this.values[key]) === null || _a === void 0 ? void 0 : _a.value;
    };
    CookieManager.prototype.set = function (key, value, options) {
        var mergedOptions = __assign(__assign({ domain: this.domain }, defaultOptions), options);
        this.values[key] = { value: value, options: mergedOptions, changed: true };
        if (this.isBrowser) {
            document.cookie = cookie.serialize(key, value, mergedOptions);
        }
    };
    CookieManager.prototype.getChanged = function () {
        var _this = this;
        return Object.keys(this.values)
            .filter(function (key) { return _this.values[key].changed; })
            .map(function (key) { return ({
            key: key,
            value: _this.values[key].value,
            options: _this.values[key].options
        }); });
    };
    return CookieManager;
}());
exports.CookieManager = CookieManager;
